import { useTranslation } from "react-i18next";
import "../../css/Swap/TokenSelection.css";
import { useContext, useEffect, useState } from "react";

import { WalletContext } from "../Wallet/WalletProvider";

function TokenSelection({
  theme,
  setTokenSelectionStatus,
  currentToken,
  setToken,
}) {
  const [active, setActive] = useState(false);

  const { tokensInfo } = useContext(WalletContext);

  useEffect(() => {
    console.log(currentToken);
    requestAnimationFrame(() => {
      setActive(true);
    });
  }, []);
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setTokenSelectionStatus(false);
          }, 150);
        }}
      ></div>

      <div className={`tokenSelectionPopupDiv ${theme} ${active && "active"}`}>
        <div className={`tokenSelectionHeaderDiv ${theme}`}>{t("Tokens")}</div>

        <div className="tokenSelectionContentDiv">
          {tokensInfo[0].tokens.map((token, index) => {
            return (
              <div
                key={index}
                className={`tokenDivfromTokenSelection ${currentToken == token.symbol && "active"}`}
                onClick={() => {
                  setActive(false);
                  setToken(token.symbol);
                  setTimeout(() => {
                    setTokenSelectionStatus(false);
                  }, 150);
                }}
              >
                <img src={token.logo}></img>
                <div>{token.symbol}</div>
                <div className={`tokenNameDivfromTokenSelection ${theme}`}>
                  {token.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default TokenSelection;
